import { useState, useEffect } from "react";

function Header() {
  const [time, setTime] = useState("");
  const [date, setDate] = useState("");

  useEffect(() => {
    const updateTime = () => {
      const now = new Date();

      const formattedTime = now.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });

      const formattedDate = now.toLocaleDateString([], {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      });

      setTime(formattedTime);
      setDate(formattedDate);
    };

    updateTime();
    const interval = setInterval(updateTime, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="d-flex justify-content-between align-items-start ms-3 mb-3">
      <img src="/logo.png" alt="Logo" />
      <div className="text-end">
        <h5 className="fw-bold mb-1" style={{ fontSize: "1.25rem" }}>
          {time}
        </h5>
        <div className="text-muted" style={{ fontSize: "0.95rem" }}>
          {date}
        </div>
      </div>
    </div>
  );
}

export default Header;
